export default __webpack_public_path__ + "static/media/13.1103e7e9.jpeg";